<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Expense/Reimbursement Claim</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">
                    Expense/Reimbursement Claim
                  </li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="row">
                  <div class="col-md-6">
                    <button
                      class="btn btn-primary dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Filter
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <a class="dropdown-item" @click="() => getApprovedExpenseClaim()"
                        >Approved Expenses</a
                      >
                      <a class="dropdown-item" @click="() => getCompletedExpenseClaim()"
                        >Completed Expenses</a
                      >
                      <a class="dropdown-item" @click="() => getPostedExpenseClaim()"
                        >Posted Expenses</a
                      >
                    </div>
                  </div>
                  <div class="col-md-6">
                    <button
                      class="btn btn-primary dropdown-toggle view-icons"
                      type="button"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      More
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a @click="exportExpenses" class="dropdown-item"
                        >Export</a
                      >
                      <a @click="openDialogGroupFrom" class="dropdown-item"
                        >Complete Claims</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="sortedExpenseClaim"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <router-link
                          :to="{
                            name: 'editExpense2',
                            params: { id: item.id }
                          }"
                          class="dropdown-item"
                          ><i class="fa fa-pencil m-r-5"></i> View</router-link
                        >
                        <a
                          class="dropdown-item"
                          @click="openDialogStatus(item)"
                          v-if="item.status == 1 && (item.amount == item.approvedAmount  || item.approvedAmount == 0)"
                          ><i class="fa fa-check"></i> Complete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.date`]="{ item }">
                    {{
                      item.date
                        ? new Date(item.date).toLocaleDateString()
                        : item.date
                    }}
                  </template>
                  <template v-slot:[`item.remark`]="{ item }">
                    {{
                      item.remark ? item.remark.substring(0, 25) : ''
                    }}
                  </template>
                  <template v-slot:[`item.unit`]="{ item }">
                    {{
                      item.assigneeEmployee.companyUnit
                        ? item.assigneeEmployee.companyUnit.name
                        : ''
                    }}
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.assigneeEmployee.firstName} ${item.assigneeEmployee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 7"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Awaiting
                      Submission
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && (item.amount == item.approvedAmount  || item.approvedAmount == 0)"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && (item.amount != item.approvedAmount && item.approvedAmount > 0)"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved But Awaiting Adjustment
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 3 && item.posted == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Completed
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 3 && item.posted == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Posted
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Delete Resignation Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Expense/Reimbursement Claim</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteExpenseClaim"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Resignation Modal -->
        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button
                  type="button"
                  class="close"
                  @click="closeStatus"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Expense/Reimbursement Claim Completion</h3>
                <p>What bank account do you use to reimburse this claim?</p>
                <select class="form-control" v-model="expense.bankAccountId">
                  <option>Selection Account</option>
                  <option :value="b.bankAccountId" v-for="b in filteredBanks" :key="b.bankAccountId">{{b.bankAccountName}}</option>
                </select>
                <div class="form-group">
                  <label>Transaction Reference <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="expense.bankReference" />
                </div>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeExpenseStatus(3)"
                      class="btn btn-primary continue-btn"
                      >Complete</a
                    >
                  </div>
                  <div class="col-6">
                    <a data-dismiss="modal" class="btn btn-primary cancel-btn" @click="closeStatus"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Approve Leave Modal -->
        
        <v-dialog v-model="dialogGroupFrom" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Expense/Reimbursement Claim Completion </h5>
              <button type="button" class="close" @click="closeGroupFrom">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>From Bank Account <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="complete.bankAccountId">
                  <option>Selection Account</option>
                  <option :value="b.bankAccountId" v-for="b in filteredBanks" :key="b.id">{{b.bankAccountName}}</option>
                </select>
                </div>
                <div class="form-group">
                  <label>Transaction Reference <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="complete.bankReference" />
                </div>
                <div class="form-group leave-duallist">
                  <label>Claim(s)</label>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterToSalaryGroup"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Search Claim</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="SPayslip_select"
                        v-model="pickExpenses"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in sortedExpenses"
                          :key="item.id"
                          >{{
                            item.assigneeEmployee.companyUnit.name + " " + item.assigneeEmployee.firstName +
                              " " +
                              item.assigneeEmployee.lastName
                          }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="SPayslip_select_rightAll"
                        @click="selectedSlipAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_rightSelected"
                        @click="selectedSlipFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_leftSelected"
                        @click="selectedSlipTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_leftAll"
                        @click="selectedSlipAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="SPayslip_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="completeExp"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialogDelete: false,
      dialogStatus: false,
      dialogGroupFrom: false,
      headers: [
        { text: 'ID', value: 'id' },
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: 'Unit', value: 'unit' },
        { text: "Remark", value: "remark" },
        { text: "J.Batch No", value: "journalBatchNo" },
        { text: "Amount", value: "amount" },
        { text: "Date", value: "date" },
        { text: "Status", value: "status" },
        { text: "", value: "actions", sortable: false }
      ],
      name: "",
      employeeId: "",
      remark: "",
      amount: "",
      assignee: "",
      assigneeId: "",
      expenseTypeId: 0,
      date: "",
      complete: {},
      // resignationDate: "",
      // resignation: {},
      selectedExpenses: [],
      expenses: [],
      expenseTypes: [],
      expense: {},
      employee: [],
      banks: [],
      pickExpenses: [],
      loading: false,
      error: "",
      employees: [],
      submitted: false,
      user: authenticationService.currentUserValue,
      company: authenticationService.currentOfficeValue,
      filterToSalaryGroup: '',
      file: null,
      fileName: null
    };
  },

  validations: {
    name: { required },
    reason: { required },
    date: { required },
    assignee: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeStatus();
    },
    dialogGroupFrom(val) {
      val || this.closeGroupFrom();
    }
  },
  computed: {
    sortedExpenseClaim: function() {
      function compare(a, b) {
        if (new Date(a.date).getTime() < new Date(b.date).getTime()) return 1;
        if (new Date(a.date).getTime() > new Date(b.date).getTime()) return -1;
        return 0;
      }

      return this.expenses ? this.expenses.sort(compare) : this.expenses;
    },
    sortedExpenses: function() {
      return this.expenses.filter(
        d =>
          d.assigneeEmployee.firstName
            .toLowerCase()
            .includes(this.filterToSalaryGroup.toLowerCase()) ||
          d.assigneeEmployee.lastName
            .toLowerCase()
            .includes(this.filterToSalaryGroup.toLowerCase())
      );
    },
    filteredBanks: function() {
      if(this.expense.assigneeEmployee && this.banks) {
      var id = this.expense.assigneeEmployee.companyUnitId != 3 || this.expense.assigneeEmployee.companyUnitId != 4 ? 2 : this.expense.assigneeEmployee.companyUnitId
      return  this.banks.filter(c=>c.companyUnitId == id)
       }else{
        return this.banks;
       } 
    }
  },
  methods: {
    clearModel() {
      this.date = "";
      this.remark = "";
      this.amount = "";
      this.assigneeId = "";
      this.file = null;
      this.fileName = null;
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      //   // console.log(this.fileName)
      // const fileReader = new FileReader()
      // fileReader.addEventListener('load', () => {
      // 	this.file = fileReader.result
      // })
      // fileReader.readAsDataURL(files[0])
      this.file = files[0];
    },

    changeFile() {
      this.file = null;
      this.fileName = "";
    },
    selectedSlipAllFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedExpenses = this.expenses;
    },
    selectedSlipFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedExpenses.push(this.pickExpenses[0]);
      // console.log(this.selectedEmployees)
    },
    selectedSlipAllTo() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      this.selectedExpenses = [];
    },
    selectedSlipTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedExpenses));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedExpenses = data;
        // console.log(this.selectedEmployees)
      });
    },
    getEmployees() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getEmployees(companyId).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getBankAccounts() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getBankAccounts().then(
        model => {
          this.banks = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getTypes() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getExpenseType(companyId).then(
        model => {
          this.expenseTypes = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },

    getApprovedExpenseClaim() {
      var companyId = this.company.id;
      employeeService.getApprovedExpenseClaims(companyId).then(
        model => {
          console.log(model);
          this.expenses = model;
        },
        error => {
          error = error;
        }
      );
    },
    getCompletedExpenseClaim() {
      var companyId = this.company.id;
      employeeService.getCompletedExpenseClaims(companyId).then(
        model => {
          console.log(model);
          this.expenses = model;
        },
        error => {
          error = error;
        }
      );
    },
    getPostedExpenseClaim() {
      var companyId = this.company.id;
      employeeService.getPostedExpenseClaims(companyId).then(
        model => {
          console.log(model);
          this.expenses = model;
        },
        error => {
          error = error;
        }
      );
    },
    completeExp() {
      this.complete.companyId = this.company.id;
      console.log(this.selectedExpenses)
      this.complete.expenseIds = this.selectedExpenses
      this.loading = true;
      employeeService.completeExpenses(this.complete).then(
        id => {
          var companyId = this.company.id;
          employeeService.getApprovedExpenseClaims(companyId).then(model => {
            console.log(model);
            this.expenses = model;
            this.closeGroupFrom();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    exportExpenses() {
      employeeService.exportClaim(this.company.id).then(response => {
        let blob = new Blob([response.data], { type: response.data.type });
        // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, response.fileName);
        } else {
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); // Create a download link
          downloadElement.href = href;
          downloadElement.download = response.fileName; // Download the file name
          document.body.appendChild(downloadElement);
          downloadElement.click(); // click to download
          document.body.removeChild(downloadElement); // Download complete removal element
          window.URL.revokeObjectURL(href); // Release Blob object
        }
      });
    },
    changeExpenseStatus(status) {
      this.submitted = true;
      this.expense.status = status;
      if (status == 1) {
        this.expense.approvedByAGM =
          this.user.employee.firstName + " " + this.user.employee.lastName;
        this.expense.approvedDateByAGM = new Date();
      }
      this.loading = true;
      employeeService.updateExpenseClaim(this.expense).then(
        id => {
          var companyId = this.company.id;
          employeeService.getApprovedExpenseClaims(companyId).then(model => {
            console.log(model);
            this.expenses = model;
            this.closeDialogStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    openDialog() {
      this.dialog = true;
    },
    openDialogStatus(item) {
      this.expense = item;
      this.dialogStatus = true;
    },
    openDialogGroupFrom() {
      this.dialogGroupFrom = true;
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeStatus() {
      this.dialogStatus = false;
      this.clearModel();
    },
    closeGroupFrom() {
      this.dialogGroupFrom = false;
      this.complete = {};
    },
    closeEdit() {
      this.dialogEdit = false;
      this.clearModel();
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setEditExpense(model) {
      this.expense = model;
      var Name = model.document.split("/");
      this.fileName = Name.length > 0 ? Name[Name.length - 1] : null;
      this.dialogEdit = true;
    },
    setDeleteExpense(model) {
      this.expense = model;
      this.dialogDelete = true;
    },
    deleteExpenseClaim() {
      this.loading = true;
      const id = this.expense.id;
      employee.removeExpenseClaim(id).then(
        id => {
          employeeService.getExpenseClaim(this.company.id).then(w => {
            (this.expenses = w), console.log(w);
            this.closeDelete();
          });
        },
        e => {
          this.error = e;
          this.loading = false;
          this.closeDelete();
        }
      );
    }
  },

  mounted() {
    this.getApprovedExpenseClaim();
    this.getEmployees();
    this.getBankAccounts();
    this.getTypes();

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "expensereports"
};
</script>



// WEBPACK FOOTER //
// src/components/expenses/Expense/listForCASHIER.vue